interface SVGProps {
  className: string;
}

export const OverviewIcon = ({ className }: SVGProps) => {
  return (
    <svg
      className={className}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.901 20.9135H20.0415V10.1765L11.7109 3.69758L3.38019 10.1765V20.9135H10.5208V13.7729H12.901V20.9135ZM22.4217 22.1036C22.4217 22.4192 22.2963 22.7219 22.0732 22.9451C21.85 23.1683 21.5473 23.2937 21.2316 23.2937H2.1901C1.87446 23.2937 1.57176 23.1683 1.34857 22.9451C1.12538 22.7219 1 22.4192 1 22.1036V9.5957C0.999874 9.41434 1.0412 9.23536 1.12081 9.07241C1.20043 8.90947 1.31623 8.76687 1.45938 8.65552L10.9801 1.25075C11.1891 1.08823 11.4462 1 11.7109 1C11.9755 1 12.2327 1.08823 12.4416 1.25075L21.9623 8.65552C22.1055 8.76687 22.2213 8.90947 22.3009 9.07241C22.3805 9.23536 22.4218 9.41434 22.4217 9.5957V22.1036V22.1036Z" />
    </svg>
  );
};

export const PlusIcon = ({ className }: SVGProps) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 11.5H18.5V12.5H13H12.5V13V18.5H11.5V13V12.5H11H5.5V11.5H11H11.5V11V5.5H12.5V11V11.5H13Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export const OrganizationIcon = ({ className }: SVGProps) => {
  return (
    <svg
      className={className}
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8V18H6V13H8V18H14V8L7 3L0 8ZM12 16H10V11H4V16H2V9.03L7 5.46L12 9.03V16Z"
        fill="currentColor"
      />
      <path d="M18 4H16V6H18V4Z" fill="currentColor" />
      <path d="M18 8H16V10H18V8Z" fill="currentColor" />
      <path d="M18 12H16V14H18V12Z" fill="currentColor" />
      <path d="M9 0V1.97L11 3.4V2H20V16H16V18H22V0H9Z" fill="currentColor" />
    </svg>
  );
};

export const InformationIcon = ({ className }: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.08496 17.5V16.85C4.08496 16.51 4.24496 16.19 4.49496 16.04C6.18496 15.03 8.11496 14.5 10.085 14.5C10.115 14.5 10.135 14.5 10.165 14.51C10.265 13.81 10.465 13.14 10.755 12.53C10.535 12.51 10.315 12.5 10.085 12.5C7.66496 12.5 5.40496 13.17 3.47496 14.32C2.59496 14.84 2.08496 15.82 2.08496 16.85V19.5H11.345C10.925 18.9 10.595 18.22 10.375 17.5H4.08496Z" />
      <path d="M10.085 11.5C12.295 11.5 14.085 9.71 14.085 7.5C14.085 5.29 12.295 3.5 10.085 3.5C7.87496 3.5 6.08496 5.29 6.08496 7.5C6.08496 9.71 7.87496 11.5 10.085 11.5ZM10.085 5.5C11.185 5.5 12.085 6.4 12.085 7.5C12.085 8.6 11.185 9.5 10.085 9.5C8.98496 9.5 8.08496 8.6 8.08496 7.5C8.08496 6.4 8.98496 5.5 10.085 5.5Z" />
      <path d="M20.835 15.5C20.835 15.28 20.805 15.08 20.775 14.87L21.915 13.86L20.915 12.13L19.465 12.62C19.145 12.35 18.785 12.14 18.385 11.99L18.085 10.5H16.085L15.785 11.99C15.385 12.14 15.025 12.35 14.705 12.62L13.255 12.13L12.255 13.86L13.395 14.87C13.365 15.08 13.335 15.28 13.335 15.5C13.335 15.72 13.365 15.92 13.395 16.13L12.255 17.14L13.255 18.87L14.705 18.38C15.025 18.65 15.385 18.86 15.785 19.01L16.085 20.5H18.085L18.385 19.01C18.785 18.86 19.145 18.65 19.465 18.38L20.915 18.87L21.915 17.14L20.775 16.13C20.805 15.92 20.835 15.72 20.835 15.5ZM17.085 17.5C15.985 17.5 15.085 16.6 15.085 15.5C15.085 14.4 15.985 13.5 17.085 13.5C18.185 13.5 19.085 14.4 19.085 15.5C19.085 16.6 18.185 17.5 17.085 17.5Z" />
    </svg>
  );
};

export const SuperAdminIcon = ({ className }: SVGProps) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 13.62C14.6186 13.62 15.12 13.1186 15.12 12.5C15.12 11.8814 14.6186 11.38 14 11.38C13.3814 11.38 12.88 11.8814 12.88 12.5C12.88 13.1186 13.3814 13.62 14 13.62Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 14.5C13.27 14.5 11.81 14.86 11.76 15.58C12.26 16.29 13.08 16.75 14 16.75C14.92 16.75 15.74 16.29 16.24 15.58C16.19 14.86 14.73 14.5 14 14.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8.09V3.27L7.5 0L0 3.27V8.18C0 12.72 3.2 16.97 7.5 18C8.05 17.87 8.58 17.68 9.1 17.45C10.18 18.99 11.97 20 14 20C17.31 20 20 17.31 20 14C20 11.03 17.84 8.57 15 8.09ZM8 14C8 14.56 8.08 15.11 8.23 15.62C7.99 15.73 7.75 15.84 7.5 15.92C4.33 14.92 2 11.68 2 8.18V4.58L7.5 2.18L13 4.58V8.09C10.16 8.57 8 11.03 8 14ZM14 18C11.79 18 10 16.21 10 14C10 11.79 11.79 10 14 10C16.21 10 18 11.79 18 14C18 16.21 16.21 18 14 18Z"
      />
    </svg>
  );
};

export const ViewIcon = ({ className }: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      width="22"
      height="16"
      viewBox="0 0 22 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 2.5C14.79 2.5 18.17 4.63 19.82 8C18.17 11.37 14.8 13.5 11 13.5C7.2 13.5 3.83 11.37 2.18 8C3.83 4.63 7.21 2.5 11 2.5ZM11 0.5C6 0.5 1.73 3.61 0 8C1.73 12.39 6 15.5 11 15.5C16 15.5 20.27 12.39 22 8C20.27 3.61 16 0.5 11 0.5ZM11 5.5C12.38 5.5 13.5 6.62 13.5 8C13.5 9.38 12.38 10.5 11 10.5C9.62 10.5 8.5 9.38 8.5 8C8.5 6.62 9.62 5.5 11 5.5ZM11 3.5C8.52 3.5 6.5 5.52 6.5 8C6.5 10.48 8.52 12.5 11 12.5C13.48 12.5 15.5 10.48 15.5 8C15.5 5.52 13.48 3.5 11 3.5Z" />
    </svg>
  );
};

export const LinkIcon = ({ className }: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17 7H13V9H17C18.65 9 20 10.35 20 12C20 13.65 18.65 15 17 15H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7ZM11 15H7C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15ZM8 11H16V13H8V11Z" />
    </svg>
  );
};

export const EditIcon = ({ className }: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.99902 21.001H6.74902L17.809 9.94103L14.059 6.19104L2.99902 17.251V21.001ZM4.99902 18.081L14.059 9.02104L14.979 9.94103L5.91902 19.001H4.99902V18.081Z"
        fill="currentColor"
      />
      <path
        d="M18.369 3.29104C17.979 2.90104 17.349 2.90104 16.959 3.29104L15.129 5.12104L18.879 8.87104L20.709 7.04104C21.099 6.65104 21.099 6.02104 20.709 5.63104L18.369 3.29104Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DeleteIcon = ({ className }: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z" />
    </svg>
  );
};

export const ArrowIcon = ({ className }: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.7049 16.59L11.1249 12L15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59Z" />
    </svg>
  );
};

export const PasswordIcon = ({ className }: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.5 20V10H16.5V11C17.2 11 17.87 11.1 18.5 11.29V10C18.5 8.9 17.6 8 16.5 8H15.5V6C15.5 3.24 13.26 1 10.5 1C7.74 1 5.5 3.24 5.5 6V8H4.5C3.4 8 2.5 8.9 2.5 10V20C2.5 21.1 3.4 22 4.5 22H10.76C10.34 21.4 10.01 20.72 9.79 20H4.5ZM7.5 6C7.5 4.34 8.84 3 10.5 3C12.16 3 13.5 4.34 13.5 6V8H7.5V6Z" />
      <path d="M16.5 13C13.74 13 11.5 15.24 11.5 18C11.5 20.76 13.74 23 16.5 23C19.26 23 21.5 20.76 21.5 18C21.5 15.24 19.26 13 16.5 13ZM16.5 15C17.33 15 18 15.67 18 16.5C18 17.33 17.33 18 16.5 18C15.67 18 15 17.33 15 16.5C15 15.67 15.67 15 16.5 15ZM16.5 21C15.47 21 14.56 20.48 14.02 19.68C14.75 19.26 15.59 19 16.5 19C17.41 19 18.25 19.26 18.98 19.68C18.44 20.48 17.53 21 16.5 21Z" />
    </svg>
  );
};

export const LogoutIcon = ({ className }: SVGProps) => {
  return (
    <svg fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
      <path d="M15.375 7.5L14.1413 8.73375L15.5238 10.125H8.375V11.875H15.5238L14.1413 13.2575L15.375 14.5L18.875 11L15.375 7.5ZM4.875 4.875H11V3.125H4.875C3.9125 3.125 3.125 3.9125 3.125 4.875V17.125C3.125 18.0875 3.9125 18.875 4.875 18.875H11V17.125H4.875V4.875Z" />
    </svg>
  );
};

export const ProfileIcon = ({ className }: SVGProps) => {
  return (
    <svg fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5 2.25C5.67 2.25 1.75 6.17 1.75 11C1.75 15.83 5.67 19.75 10.5 19.75C15.33 19.75 19.25 15.83 19.25 11C19.25 6.17 15.33 2.25 10.5 2.25ZM6.43125 16.6875C7.5775 15.865 8.9775 15.375 10.5 15.375C12.0225 15.375 13.4225 15.865 14.5687 16.6875C13.4225 17.51 12.0225 18 10.5 18C8.9775 18 7.5775 17.51 6.43125 16.6875ZM15.8725 15.48C14.3937 14.325 12.53 13.625 10.5 13.625C8.47 13.625 6.60625 14.325 5.1275 15.48C4.1125 14.2638 3.5 12.7063 3.5 11C3.5 7.1325 6.6325 4 10.5 4C14.3675 4 17.5 7.1325 17.5 11C17.5 12.7063 16.8875 14.2638 15.8725 15.48Z"
        fill="white"
      />
      <path
        d="M10.5 5.75C8.81125 5.75 7.4375 7.12375 7.4375 8.8125C7.4375 10.5013 8.81125 11.875 10.5 11.875C12.1888 11.875 13.5625 10.5013 13.5625 8.8125C13.5625 7.12375 12.1888 5.75 10.5 5.75ZM10.5 10.125C9.77375 10.125 9.1875 9.53875 9.1875 8.8125C9.1875 8.08625 9.77375 7.5 10.5 7.5C11.2262 7.5 11.8125 8.08625 11.8125 8.8125C11.8125 9.53875 11.2262 10.125 10.5 10.125Z"
        fill="white"
      />
    </svg>
  );
};

export const CloseIcon = ({ className }: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.02083 12.8333V7.16667L6.1875 10L9.02083 12.8333ZM3.75 17.5C3.40625 17.5 3.11198 17.3776 2.86719 17.1328C2.6224 16.888 2.5 16.5938 2.5 16.25V3.75C2.5 3.40625 2.6224 3.11198 2.86719 2.86719C3.11198 2.6224 3.40625 2.5 3.75 2.5H16.25C16.5938 2.5 16.888 2.6224 17.1328 2.86719C17.3776 3.11198 17.5 3.40625 17.5 3.75V16.25C17.5 16.5938 17.3776 16.888 17.1328 17.1328C16.888 17.3776 16.5938 17.5 16.25 17.5H3.75ZM13.1875 16.25H16.25V3.75H13.1875V16.25ZM11.9375 16.25V3.75H3.75V16.25H11.9375Z" />
    </svg>
  );
};

export const ActionIcon = ({ className }: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.99992 8.33337C4.08325 8.33337 3.33325 9.08337 3.33325 10C3.33325 10.9167 4.08325 11.6667 4.99992 11.6667C5.91659 11.6667 6.66659 10.9167 6.66659 10C6.66659 9.08337 5.91659 8.33337 4.99992 8.33337ZM14.9999 8.33337C14.0833 8.33337 13.3333 9.08337 13.3333 10C13.3333 10.9167 14.0833 11.6667 14.9999 11.6667C15.9166 11.6667 16.6666 10.9167 16.6666 10C16.6666 9.08337 15.9166 8.33337 14.9999 8.33337ZM9.99992 8.33337C9.08325 8.33337 8.33325 9.08337 8.33325 10C8.33325 10.9167 9.08325 11.6667 9.99992 11.6667C10.9166 11.6667 11.6666 10.9167 11.6666 10C11.6666 9.08337 10.9166 8.33337 9.99992 8.33337Z" />
    </svg>
  );
};

export const XIcon = ({ className }: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.59216 7.00036L13.0453 2.54724C13.2566 2.33627 13.3755 2.04998 13.3758 1.75136C13.376 1.45274 13.2577 1.16624 13.0467 0.954896C12.8357 0.743551 12.5494 0.624671 12.2508 0.624408C11.9522 0.624144 11.6657 0.742518 11.4543 0.95349L7.00122 5.40661L2.54809 0.95349C2.33675 0.742145 2.05011 0.623413 1.75122 0.623413C1.45233 0.623413 1.16569 0.742145 0.954344 0.95349C0.743 1.16483 0.624268 1.45148 0.624268 1.75036C0.624268 2.04925 0.743 2.3359 0.954344 2.54724L5.40747 7.00036L0.954344 11.4535C0.743 11.6648 0.624268 11.9515 0.624268 12.2504C0.624268 12.5493 0.743 12.8359 0.954344 13.0472C1.16569 13.2586 1.45233 13.3773 1.75122 13.3773C2.05011 13.3773 2.33675 13.2586 2.54809 13.0472L7.00122 8.59411L11.4543 13.0472C11.6657 13.2586 11.9523 13.3773 12.2512 13.3773C12.5501 13.3773 12.8367 13.2586 13.0481 13.0472C13.2594 12.8359 13.3782 12.5493 13.3782 12.2504C13.3782 11.9515 13.2594 11.6648 13.0481 11.4535L8.59216 7.00036Z" />
    </svg>
  );
};

export const SuccessIcon = ({ className }: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.125 9.99902C1.125 12.4854 2.11272 14.87 3.87087 16.6281C5.62903 18.3863 8.0136 19.374 10.5 19.374C12.9864 19.374 15.371 18.3863 17.1291 16.6281C18.8873 14.87 19.875 12.4854 19.875 9.99902C19.875 7.51262 18.8873 5.12805 17.1291 3.3699C15.371 1.61174 12.9864 0.624023 10.5 0.624023C8.0136 0.624023 5.62903 1.61174 3.87087 3.3699C2.11272 5.12805 1.125 7.51262 1.125 9.99902Z"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 10.1591L8.72581 13.3337L15.5 6.66699"
        stroke="white"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MoreIcon = ({ className }: SVGProps) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4322 10.98C17.4722 10.66 17.5022 10.34 17.5022 10C17.5022 9.66 17.4722 9.34 17.4322 9.02L19.5422 7.37C19.7322 7.22 19.7822 6.95 19.6622 6.73L17.6622 3.27C17.5722 3.11 17.4022 3.02 17.2222 3.02C17.1622 3.02 17.1022 3.03 17.0522 3.05L14.5622 4.05C14.0422 3.65 13.4822 3.32 12.8722 3.07L12.4922 0.42C12.4622 0.18 12.2522 0 12.0022 0H8.00216C7.75216 0 7.54216 0.18 7.51216 0.42L7.13216 3.07C6.52216 3.32 5.96216 3.66 5.44216 4.05L2.95216 3.05C2.89216 3.03 2.83216 3.02 2.77216 3.02C2.60216 3.02 2.43216 3.11 2.34216 3.27L0.342159 6.73C0.212159 6.95 0.272159 7.22 0.462159 7.37L2.57216 9.02C2.53216 9.34 2.50216 9.67 2.50216 10C2.50216 10.33 2.53216 10.66 2.57216 10.98L0.462159 12.63C0.272159 12.78 0.222159 13.05 0.342159 13.27L2.34216 16.73C2.43216 16.89 2.60216 16.98 2.78216 16.98C2.84216 16.98 2.90216 16.97 2.95216 16.95L5.44216 15.95C5.96216 16.35 6.52216 16.68 7.13216 16.93L7.51216 19.58C7.54216 19.82 7.75216 20 8.00216 20H12.0022C12.2522 20 12.4622 19.82 12.4922 19.58L12.8722 16.93C13.4822 16.68 14.0422 16.34 14.5622 15.95L17.0522 16.95C17.1122 16.97 17.1722 16.98 17.2322 16.98C17.4022 16.98 17.5722 16.89 17.6622 16.73L19.6622 13.27C19.7822 13.05 19.7322 12.78 19.5422 12.63L17.4322 10.98ZM15.4522 9.27C15.4922 9.58 15.5022 9.79 15.5022 10C15.5022 10.21 15.4822 10.43 15.4522 10.73L15.3122 11.86L16.2022 12.56L17.2822 13.4L16.5822 14.61L15.3122 14.1L14.2722 13.68L13.3722 14.36C12.9422 14.68 12.5322 14.92 12.1222 15.09L11.0622 15.52L10.9022 16.65L10.7022 18H9.30216L8.95216 15.52L7.89216 15.09C7.46216 14.91 7.06216 14.68 6.66216 14.38L5.75216 13.68L4.69216 14.11L3.42216 14.62L2.72216 13.41L3.80216 12.57L4.69216 11.87L4.55216 10.74C4.52216 10.43 4.50216 10.2 4.50216 10C4.50216 9.8 4.52216 9.57 4.55216 9.27L4.69216 8.14L3.80216 7.44L2.72216 6.6L3.42216 5.39L4.69216 5.9L5.73216 6.32L6.63216 5.64C7.06216 5.32 7.47216 5.08 7.88216 4.91L8.94216 4.48L9.10216 3.35L9.30216 2H10.6922L11.0422 4.48L12.1022 4.91C12.5322 5.09 12.9322 5.32 13.3322 5.62L14.2422 6.32L15.3022 5.89L16.5722 5.38L17.2722 6.59L16.2022 7.44L15.3122 8.14L15.4522 9.27ZM10.0022 6C7.79216 6 6.00216 7.79 6.00216 10C6.00216 12.21 7.79216 14 10.0022 14C12.2122 14 14.0022 12.21 14.0022 10C14.0022 7.79 12.2122 6 10.0022 6ZM10.0022 12C8.90216 12 8.00216 11.1 8.00216 10C8.00216 8.9 8.90216 8 10.0022 8C11.1022 8 12.0022 8.9 12.0022 10C12.0022 11.1 11.1022 12 10.0022 12Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EmptyContentIcon = ({ className }: SVGProps) => {
  return (
    <svg
      className={className}
      width="274"
      height="274"
      viewBox="0 0 274 274"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.57"
        d="M248.081 189.777V196.418C248.081 199.383 245.692 201.798 242.729 201.798H225.229L229.301 194.594L239.725 176.134C244.677 178.642 248.081 183.808 248.081 189.777Z"
        fill="#F9E1B8"
      />
      <path
        d="M165.818 196.283L174.454 201.784H139.776C149.04 201.797 157.849 199.825 165.818 196.283Z"
        fill="#F9CB34"
      />
      <path
        d="M239.726 176.12L229.301 194.58L199.122 174.497V174.47H232.865C235.334 174.483 237.657 175.073 239.726 176.12Z"
        fill="#21BDB9"
      />
      <path
        opacity="0.57"
        d="M229.301 194.593L229.047 195.036L228.073 196.767L225.39 201.502L225.229 201.784H184.612L184.639 201.382L184.812 198.444L184.946 196.163L185.159 192.514L185.186 192.111L185.733 182.466C188.162 179.997 190.391 177.314 192.394 174.483H199.148V174.51L226.644 192.809L228.313 193.923L229.301 194.593Z"
        fill="#22D3EE"
      />
      <path
        opacity="0.57"
        d="M135.292 72.3641C136.773 72.2568 138.268 72.2031 139.776 72.2031C175.389 72.2031 204.247 101.208 204.247 137C204.247 150.966 199.855 163.898 192.367 174.483C190.365 177.327 188.136 179.997 185.706 182.466C180.047 188.248 173.306 192.957 165.818 196.284C157.849 199.825 149.04 201.784 139.776 201.784C138.268 201.784 136.773 201.73 135.292 201.623C101.775 199.329 75.3062 171.264 75.3062 137C75.3062 102.737 101.775 74.6716 135.292 72.3641Z"
        fill="#64748B"
      />
      <path
        opacity="0.57"
        d="M185.706 182.466L184.612 201.784H174.454L165.818 196.284C173.306 192.97 180.047 188.248 185.706 182.466Z"
        fill="#67E8F9"
      />
      <path
        opacity="0.97"
        d="M78.1623 174.483C72.5429 166.528 68.6586 157.244 67.0836 147.196C66.563 143.869 66.2827 140.462 66.2827 137C66.2827 101.208 95.1409 72.2031 130.753 72.2031C132.275 72.2031 133.796 72.2568 135.291 72.3641C101.775 74.6716 75.3059 102.737 75.3059 137C75.3059 171.264 101.775 199.329 135.291 201.636C133.796 201.744 132.275 201.797 130.753 201.797C129.805 201.797 128.844 201.771 127.91 201.73C107.381 200.832 89.3479 190.3 78.189 174.51C78.1757 174.497 78.1623 174.497 78.1623 174.483Z"
        fill="#F9CB34"
      />
      <path
        opacity="0.57"
        d="M127.91 201.731V201.798H31.5652C30.4707 201.798 29.4696 201.436 28.6553 200.832C27.4674 199.946 26.6799 198.524 26.6665 196.928V189.938C26.6665 188.49 26.8667 187.094 27.2405 185.766C27.2805 185.619 27.3205 185.471 27.3739 185.323C27.7477 184.116 28.2682 182.976 28.9089 181.916C30.1503 179.877 31.8321 178.146 33.8477 176.872C34.2481 176.617 34.6485 176.389 35.0757 176.174C37.1713 175.101 39.5472 174.497 42.0566 174.497H53.0152V174.524H78.1893C83.395 181.876 90.0823 188.1 97.8241 192.729C99.4792 193.722 101.174 194.634 102.91 195.466C102.936 195.479 102.963 195.492 102.99 195.506C104.858 196.405 106.781 197.21 108.743 197.934C114.763 200.121 121.196 201.436 127.91 201.731Z"
        fill="#64748B"
      />
      <path
        d="M78.1627 174.483H53.002V157.257C53.002 151.703 57.4868 147.209 63.0129 147.209H67.084C67.2041 147.987 67.3376 148.765 67.4978 149.53C67.5511 149.812 67.6045 150.093 67.6713 150.375C68.619 154.936 70.0472 159.323 71.9026 163.482C72.61 165.079 73.3975 166.648 74.2251 168.178C75.413 170.351 76.7345 172.457 78.1627 174.483Z"
        fill="#06B6D4"
      />
      <g opacity="0.57">
        <path
          opacity="0.57"
          d="M44.2992 185.484L47.8231 181.406C49.1445 179.877 48.9843 177.556 47.4627 176.228L45.287 174.336L43.2982 176.697L45.8876 178.951L42.0034 183.566L44.2992 185.484Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M53.0685 173.812L49.5447 177.757C48.1965 179.273 48.3167 181.594 49.825 182.948L51.974 184.88L53.9895 182.546L51.4401 180.252L55.3243 175.771L53.0685 173.812Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M60.9696 201.797L61.023 197.746L57.606 197.665L57.6327 194.566L60.5158 194.633C61.7171 194.66 62.7849 195.277 63.4256 196.203C63.5457 196.378 63.6525 196.565 63.746 196.753C63.9729 197.25 64.1064 197.813 64.093 198.403L64.0129 201.797H60.9696Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M63.307 189.2L63.0801 194.499C63 196.525 64.5617 198.242 66.5772 198.323L69.4604 198.444L69.5404 195.358L66.1234 195.21L66.2969 189.267L63.307 189.2Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M44.045 201.797H40.5879L39.5868 199.986L36.5702 201.609L35.0752 198.899L37.6113 197.531C38.6791 196.954 39.8938 196.967 40.9082 197.45C41.0951 197.544 41.282 197.652 41.4555 197.772C41.896 198.094 42.2831 198.51 42.55 199.02L44.045 201.797Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M37.3579 191.427L39.7739 196.15C40.6949 197.947 42.9106 198.658 44.6992 197.733L47.262 196.404L45.8071 193.681L42.7638 195.264L39.9874 190.019L37.3579 191.427Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M26.4662 185.026C26.2793 184.933 26.0925 184.826 25.9189 184.706C26.1192 184.799 26.2927 184.906 26.4662 185.026Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M30.1239 191.052L27.5211 192.527L26.6802 191.011V189.952C26.6802 188.503 26.8804 187.107 27.2541 185.779C27.3743 185.94 27.4944 186.115 27.5878 186.303L30.1239 191.052Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M25.9189 184.706C26.1058 184.799 26.2927 184.906 26.4662 185.026C26.2793 184.933 26.0925 184.826 25.9189 184.706Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M32.2729 183.646L29.7101 184.974C28.9626 185.363 28.135 185.471 27.3608 185.323C27.7346 184.116 28.2551 182.975 28.8958 181.916L30.8046 180.923L32.2729 183.646Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M83.8359 193.587L81.2865 188.824C80.3254 187.04 78.1097 186.369 76.3344 187.322L73.7983 188.69L75.2933 191.4L78.3099 189.777L81.2198 195.062L83.8359 193.587Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M76.0933 181.218L78.5092 185.941C79.4302 187.738 81.646 188.449 83.4346 187.524L85.9974 186.195L84.5425 183.472L81.4992 185.055L78.7228 179.81L76.0933 181.218Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M88.2267 197.049L90.7495 201.798H87.3057L85.5972 198.484L88.2267 197.049Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M94.6333 201.798H91.9771L94.0593 200.725L94.6333 201.798Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M98.9189 201.798L100.32 196.619L97.0234 195.68L97.811 192.715V192.688L100.587 193.48C101.655 193.789 102.469 194.526 102.897 195.466C102.937 195.559 102.977 195.64 103.003 195.734C103.083 195.935 103.137 196.136 103.177 196.338C103.284 196.874 103.257 197.451 103.097 198.014L102.029 201.798H98.9189Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M108.742 197.92L108.315 199.409L105.552 198.577C104.418 198.228 103.577 197.383 103.19 196.35C103.123 196.149 103.056 195.948 103.016 195.746C103.003 195.666 102.989 195.585 102.976 195.505C104.858 196.39 106.78 197.209 108.742 197.92Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M68.1112 174.51C67.951 174.885 67.7241 175.221 67.4438 175.529C67.2969 175.69 67.1501 175.824 66.9766 175.945C66.5361 176.281 66.0155 176.522 65.4416 176.629L60.1558 177.622L59.5552 174.684L60.4094 174.51H68.1112Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M74.3451 174.51L74.799 176.898L68.9793 177.971L69.5533 181.365L66.5233 181.929L66.0294 179.071C65.8292 177.89 66.2163 176.75 66.9638 175.945C67.1106 175.798 67.2574 175.65 67.431 175.529C67.8848 175.181 68.4187 174.939 69.0193 174.845L70.9281 174.523H74.3451V174.51Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M28.9623 197.116L28.6553 200.832C27.4674 199.946 26.6799 198.524 26.6665 196.928L28.9623 197.116Z"
          fill="#F7C992"
        />
        <path
          opacity="0.57"
          d="M35.0757 176.831L33.8477 176.871C34.2481 176.617 34.6485 176.388 35.0757 176.174V176.831Z"
          fill="#F7C992"
        />
      </g>
      <g opacity="0.57">
        <path
          opacity="0.57"
          d="M189.35 188.489L191.566 185.927C192.394 184.961 192.3 183.498 191.339 182.667L189.964 181.473L188.723 182.962L190.351 184.384L187.909 187.282L189.35 188.489Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M194.849 181.15L192.634 183.632C191.78 184.585 191.86 186.047 192.807 186.892L194.155 188.113L195.423 186.651L193.822 185.202L196.264 182.385L194.849 181.15Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M196.918 174.121C196.905 174.242 196.892 174.363 196.865 174.483C196.865 174.483 196.865 174.497 196.865 174.51C196.785 174.846 196.611 175.168 196.371 175.449L194.155 178.012L192.714 176.804L194.649 174.497H196.865C196.865 174.363 196.878 174.242 196.918 174.121Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M200.228 176.16L198.96 177.622L197.612 176.401C197.051 175.905 196.798 175.194 196.851 174.496C196.851 174.483 196.851 174.483 196.851 174.47C196.865 174.349 196.878 174.228 196.918 174.107C196.905 174.228 196.891 174.349 196.865 174.47H198.84L198.64 174.698L200.228 176.16Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M201.683 199.986L201.763 196.592C201.79 195.317 200.789 194.257 199.521 194.231L197.706 194.19L197.692 196.136L199.841 196.189L199.801 199.986H201.683Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M201.284 190.81L201.137 194.137C201.083 195.411 202.071 196.484 203.339 196.538L205.155 196.605L205.208 194.66L203.059 194.566L203.166 190.836L201.284 190.81Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M184.932 196.177L185.145 196.056C185.813 195.694 186.587 195.707 187.227 196.016C187.334 196.069 187.454 196.136 187.548 196.204C187.828 196.405 188.082 196.673 188.255 196.995L189.857 199.987L188.215 200.912L186.387 197.585L184.812 198.444L184.932 196.177Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M184.985 192.218L186.507 195.183C187.094 196.31 188.469 196.766 189.603 196.176L191.218 195.344L190.311 193.627L188.402 194.62L186.653 191.319L184.985 192.218Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M207.65 201.797H205.501L205.167 201.14L206.823 200.241L207.65 201.797Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M214.19 193.574L212.588 190.582C211.988 189.455 210.599 189.039 209.478 189.643L207.876 190.502L208.811 192.205L210.706 191.186L212.535 194.513L214.19 193.574Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M209.318 185.792L210.84 188.757C211.427 189.884 212.802 190.34 213.937 189.75L215.552 188.918L214.644 187.201L212.735 188.194L210.987 184.894L209.318 185.792Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M216.701 201.798H218.769L218.569 201.435C218.396 201.1 218.142 200.832 217.862 200.63C217.755 200.563 217.648 200.496 217.541 200.442C216.901 200.134 216.127 200.134 215.459 200.483L213.857 201.341L214.098 201.784H216.701V201.798Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M215.298 196.646L216.82 199.611C217.407 200.738 218.782 201.194 219.917 200.603L221.532 199.772L220.624 198.055L218.715 199.047L216.967 195.747L215.298 196.646Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M225.389 199.624L226.31 196.351C226.658 195.13 225.95 193.842 224.735 193.493L222.987 192.997L222.479 194.875L224.548 195.466L223.561 199.128L225.389 199.624Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M229.048 195.036L228.06 194.74L228.3 193.922L226.632 192.809L226.325 193.828C226.218 194.19 226.205 194.566 226.258 194.915C226.285 195.049 226.311 195.17 226.365 195.29C226.605 195.948 227.139 196.471 227.846 196.699L228.06 196.766L229.048 195.036Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M224.856 201.354L225.39 201.515L225.229 201.797H224.722L224.856 201.354Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M199.308 183.539L202.632 182.909C203.873 182.667 204.701 181.473 204.461 180.212L204.127 178.428L202.231 178.817L202.632 180.936L198.935 181.688L199.308 183.539Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M208.157 181.231L204.887 181.795C203.632 182.01 202.791 183.204 203.005 184.465L203.312 186.262L205.207 185.9L204.847 183.767L208.504 183.096L208.157 181.231Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M197.6 201.797H196.972L197.026 201.623L197.6 201.797Z"
          fill="#F2AB55"
        />
        <path
          opacity="0.57"
          d="M184.639 201.382L184.852 201.798H184.612L184.639 201.382Z"
          fill="#F2AB55"
        />
      </g>
      <g opacity="0.57">
        <path
          opacity="0.57"
          d="M60.1167 156.923L62.6395 153.998C63.5872 152.898 63.467 151.234 62.3859 150.295L60.8242 148.94L59.4093 150.631L61.2646 152.241L58.4883 155.541L60.1167 156.923Z"
          fill="#F9E1B8"
        />
        <path
          opacity="0.57"
          d="M66.3903 148.564L63.8676 151.395C62.9065 152.482 62.9866 154.132 64.0678 155.111L65.6028 156.493L67.0444 154.83L65.2157 153.193L68.0054 149.987L66.3903 148.564Z"
          fill="#F9E1B8"
        />
        <path
          opacity="0.57"
          d="M74.2256 168.164L74.1856 170.015L72.0499 170.002L72.1033 165.682L69.6606 165.629L69.6873 163.415L71.7563 163.469C71.8097 163.469 71.8764 163.469 71.9298 163.482C72.6105 165.079 73.3847 166.635 74.2256 168.164Z"
          fill="#F9E1B8"
        />
        <path
          opacity="0.57"
          d="M60.7035 170.029L58.8881 166.622C58.2074 165.347 56.619 164.864 55.351 165.548L53.5356 166.528L54.6035 168.459L56.7658 167.292L58.8481 171.075L60.7035 170.029Z"
          fill="#F9E1B8"
        />
        <path
          opacity="0.57"
          d="M55.1509 161.175L56.8861 164.555C57.5535 165.843 59.1285 166.353 60.4099 165.682L62.2386 164.73L61.1975 162.785L59.0218 163.912L57.0329 160.155L55.1509 161.175Z"
          fill="#F9E1B8"
        />
        <path
          opacity="0.57"
          d="M70.9815 172.525L70.3675 174.483H63.6401L64.0806 172.981L68.125 174.229L68.8725 171.881L70.9815 172.525Z"
          fill="#F9E1B8"
        />
        <path
          opacity="0.57"
          d="M54.4304 170.995L56.2857 174.483H53.8164L53.0022 172.914L52.5483 172.015L53.0022 171.773L54.4304 170.995Z"
          fill="#F9E1B8"
        />
        <path
          opacity="0.57"
          d="M59.0623 174.484H56.9399L58.5951 173.625L59.0623 174.484Z"
          fill="#F9E1B8"
        />
      </g>
      <path
        d="M190.216 119.435C193.473 119.435 196.114 116.795 196.114 113.537C196.114 110.28 193.473 107.64 190.216 107.64C186.959 107.64 184.318 110.28 184.318 113.537C184.318 116.795 186.959 119.435 190.216 119.435Z"
        fill="#67E8F9"
      />
      <path
        d="M190.216 100.379C186.844 100.379 184.119 97.6545 184.119 94.282V66.2885C184.119 62.916 186.844 60.1914 190.216 60.1914C193.589 60.1914 196.313 62.916 196.313 66.2885V94.2654C196.313 97.6379 193.589 100.379 190.216 100.379Z"
        fill="#67E8F9"
      />
      <path
        d="M123.167 135.666V139.333H119.5V135.666H123.167ZM123.167 145V148.666H119.5V145H123.167ZM123.167 126.333V130H119.5V126.333H123.167ZM160.5 135.666V139.333H128.833V135.666H160.5ZM160.5 145V148.666H128.833V145H160.5ZM160.5 130H128.833V126.333H160.5V130Z"
        fill="white"
        stroke="white"
      />
    </svg>
  );
};

export const UserIcon = ({ className }: SVGProps) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.9375 3.5C3.9375 4.31223 4.26016 5.09118 4.83449 5.66551C5.40882 6.23984 6.18777 6.5625 7 6.5625C7.81223 6.5625 8.59118 6.23984 9.16551 5.66551C9.73984 5.09118 10.0625 4.31223 10.0625 3.5C10.0625 2.68777 9.73984 1.90882 9.16551 1.33449C8.59118 0.760155 7.81223 0.4375 7 0.4375C6.18777 0.4375 5.40882 0.760155 4.83449 1.33449C4.26016 1.90882 3.9375 2.68777 3.9375 3.5V3.5Z"
        stroke="#F3F4F6"
        stroke-width="0.875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.3125 13.5625C1.3125 12.0541 1.91172 10.6074 2.97833 9.54083C4.04494 8.47422 5.49158 7.875 7 7.875C8.50842 7.875 9.95506 8.47422 11.0217 9.54083C12.0883 10.6074 12.6875 12.0541 12.6875 13.5625"
        stroke="#F3F4F6"
        stroke-width="0.875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ResearcherIcon = ({ className }: SVGProps) => {
  return (
    <svg fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 8.25C9.1575 8.25 10.5 6.9075 10.5 5.25C10.5 3.5925 9.1575 2.25 7.5 2.25C5.8425 2.25 4.5 3.5925 4.5 5.25C4.5 6.9075 5.8425 8.25 7.5 8.25ZM7.5 3.75C8.325 3.75 9 4.425 9 5.25C9 6.075 8.325 6.75 7.5 6.75C6.675 6.75 6 6.075 6 5.25C6 4.425 6.675 3.75 7.5 3.75Z"
        fill="currentColor"
      />
      <path
        d="M3 12.75C3.165 12.21 5.4825 11.25 7.5 11.25C7.5 10.725 7.5975 10.2225 7.7625 9.7575C5.715 9.6825 1.5 10.7025 1.5 12.75V14.25H8.655C8.265 13.815 7.9575 13.3125 7.7625 12.75H3Z"
        fill="currentColor"
      />
      <path
        d="M14.5725 12.765C14.8425 12.3225 15 11.805 15 11.25C15 9.5925 13.6575 8.25 12 8.25C10.3425 8.25 9 9.5925 9 11.25C9 12.9075 10.3425 14.25 12 14.25C12.555 14.25 13.0725 14.085 13.515 13.8225C14.2125 14.52 14.73 15.0375 15.4425 15.75L16.5 14.6925C15.375 13.5675 15.9075 14.0925 14.5725 12.765ZM12 12.75C11.175 12.75 10.5 12.075 10.5 11.25C10.5 10.425 11.175 9.75 12 9.75C12.825 9.75 13.5 10.425 13.5 11.25C13.5 12.075 12.825 12.75 12 12.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StudyIcon = ({ className }: SVGProps) => {
  return (
    <svg fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.75 10.3125C4.995 10.3125 1.5 11.19 1.5 12.9375V14.25H12V12.9375C12 11.19 8.505 10.3125 6.75 10.3125ZM3.255 12.75C3.885 12.315 5.4075 11.8125 6.75 11.8125C8.0925 11.8125 9.615 12.315 10.245 12.75H3.255ZM6.75 9C8.1975 9 9.375 7.8225 9.375 6.375C9.375 4.9275 8.1975 3.75 6.75 3.75C5.3025 3.75 4.125 4.9275 4.125 6.375C4.125 7.8225 5.3025 9 6.75 9ZM6.75 5.25C7.3725 5.25 7.875 5.7525 7.875 6.375C7.875 6.9975 7.3725 7.5 6.75 7.5C6.1275 7.5 5.625 6.9975 5.625 6.375C5.625 5.7525 6.1275 5.25 6.75 5.25ZM12.03 10.3575C12.9 10.9875 13.5 11.8275 13.5 12.9375V14.25H16.5V12.9375C16.5 11.4225 13.875 10.56 12.03 10.3575ZM11.25 9C12.6975 9 13.875 7.8225 13.875 6.375C13.875 4.9275 12.6975 3.75 11.25 3.75C10.845 3.75 10.47 3.8475 10.125 4.0125C10.5975 4.68 10.875 5.4975 10.875 6.375C10.875 7.2525 10.5975 8.07 10.125 8.7375C10.47 8.9025 10.845 9 11.25 9Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DeleteIconFill = ({
  fill = '#EE4932',
  className = '',
}: {
  fill?: string;
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="delete">
        <path
          id="Vector"
          d="M5.00033 15.8333C5.00033 16.75 5.75033 17.5 6.66699 17.5H13.3337C14.2503 17.5 15.0003 16.75 15.0003 15.8333V5.83333H5.00033V15.8333ZM15.8337 3.33333H12.917L12.0837 2.5H7.91699L7.08366 3.33333H4.16699V5H15.8337V3.33333Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const AddFileIcon = ({ className }: SVGProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
    >
      <g clipPath="url(#clip0_1240_34499)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.44899 1.16286C7.19172 0.419199 8.19938 0.000927383 9.25042 2.10766e-06H25.1076C25.2812 -0.000308024 25.4532 0.0336105 25.6137 0.0998186C25.7743 0.166027 25.9202 0.263226 26.0431 0.385859L36.6146 10.9573C36.7372 11.0802 36.8344 11.2261 36.9006 11.3867C36.9668 11.5472 37.0007 11.7192 37.0004 11.8929V33.0357C37.0004 34.0871 36.5828 35.0954 35.8393 35.8389C35.0959 36.5823 34.0875 37 33.0361 37H13.4922C13.738 36.3869 13.8754 35.7182 13.8754 35.0179V33.6964H15.1968C16.5987 33.6964 17.9431 33.1395 18.9344 32.1483C19.9257 31.157 20.4826 29.8126 20.4826 28.4107C20.4826 27.0089 19.9257 25.6644 18.9344 24.6732C17.9431 23.6819 16.5987 23.125 15.1968 23.125H13.8754V21.8036C13.8753 20.8078 13.5939 19.8323 13.0636 18.9895C12.5334 18.1466 11.7758 17.4707 10.8782 17.0396C9.98059 16.6085 8.97946 16.4397 7.99011 16.5526C7.00077 16.6656 6.06346 17.0557 5.28613 17.6781V3.96429C5.28613 2.91243 5.7037 1.90286 6.44899 1.16286Z"
          fill="#64748B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.58929 19.8213C9.11498 19.8213 9.61915 20.0301 9.99087 20.4018C10.3626 20.7736 10.5714 21.2777 10.5714 21.8034V26.4284H15.1964C15.7221 26.4284 16.2263 26.6373 16.598 27.009C16.9697 27.3807 17.1786 27.8849 17.1786 28.4106C17.1786 28.9363 16.9697 29.4404 16.598 29.8122C16.2263 30.1839 15.7221 30.3927 15.1964 30.3927H10.5714V35.0177C10.5714 35.5434 10.3626 36.0476 9.99087 36.4193C9.61915 36.791 9.11498 36.9999 8.58929 36.9999C8.06359 36.9999 7.55942 36.791 7.1877 36.4193C6.81597 36.0476 6.60714 35.5434 6.60714 35.0177V30.3927H1.98214C1.45645 30.3927 0.95228 30.1839 0.580556 29.8122C0.208832 29.4404 0 28.9363 0 28.4106C0 27.8849 0.208832 27.3807 0.580556 27.009C0.95228 26.6373 1.45645 26.4284 1.98214 26.4284H6.60714V21.8034C6.60714 21.2777 6.81597 20.7736 7.1877 20.4018C7.55942 20.0301 8.06359 19.8213 8.58929 19.8213Z"
          fill="#34445A"
        />
      </g>
      <defs>
        <clipPath id="clip0_1240_34499">
          <rect width="37" height="37" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DocumentIcon = ({ className }: SVGProps) => {
  return (
    <svg
      className={className}
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.875 25.5785C21.8637 25.4879 21.8197 25.4046 21.7514 25.3442C21.683 25.2837 21.595 25.2502 21.5037 25.25H15.5037C15.4123 25.25 15.3241 25.2834 15.2556 25.3439C15.1871 25.4044 15.1431 25.4878 15.1317 25.5785L14.546 30.2645C14.512 30.5367 14.3797 30.787 14.174 30.9685C13.9684 31.15 13.7035 31.2501 13.4292 31.25H11.2917C10.9106 31.2501 10.5391 31.3701 10.2299 31.593C9.92076 31.8159 9.68953 32.1304 9.56898 32.492C9.50208 32.6928 9.48384 32.9066 9.51579 33.1159C9.54774 33.3251 9.62895 33.5238 9.75274 33.6954C9.87653 33.8671 10.0393 34.0069 10.2278 34.1034C10.4162 34.1998 10.6248 34.25 10.8365 34.25H26.1702C26.3819 34.25 26.5905 34.1998 26.779 34.1034C26.9674 34.0069 27.1302 33.8671 27.254 33.6954C27.3778 33.5238 27.459 33.3251 27.4909 33.1159C27.5229 32.9066 27.5046 32.6928 27.4377 32.492C27.3172 32.1304 27.086 31.8159 26.7768 31.593C26.4676 31.3701 26.0961 31.2501 25.715 31.25H23.5775C23.3033 31.2499 23.0386 31.1497 22.8331 30.9683C22.6276 30.7868 22.4955 30.5365 22.4615 30.2645L21.875 25.5785Z"
        fill="#34445A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.59375 27.563C9.038 27.7153 12.9327 27.875 18.5 27.875C24.0672 27.875 27.962 27.7153 30.4062 27.563C32.8333 27.4123 34.8073 25.6115 35.0368 23.138C35.213 21.2435 35.375 18.485 35.375 14.75C35.375 11.015 35.213 8.2565 35.0375 6.36275C34.8073 3.8885 32.8333 2.08775 30.4062 1.937C27.962 1.78475 24.0672 1.625 18.5 1.625C12.9327 1.625 9.038 1.78475 6.59375 1.937C4.16675 2.08775 2.19275 3.8885 1.96325 6.362C1.787 8.25725 1.625 11.015 1.625 14.75C1.625 18.485 1.787 21.2435 1.9625 23.1373C2.19275 25.6115 4.16675 27.4123 6.59375 27.563Z"
        fill="#64748B"
      />
      <path
        d="M13.25 1.67753V27.8225C10.379 27.7625 8.18 27.6613 6.59375 27.5623C4.16675 27.4123 2.19275 25.6108 1.96325 23.1373C1.787 21.2428 1.625 18.485 1.625 14.75C1.625 11.015 1.787 8.25728 1.9625 6.36278C2.19275 3.88853 4.16675 2.08778 6.59375 1.93778C8.81047 1.80495 11.0297 1.71769 13.25 1.67603V1.67753Z"
        fill="#34445A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.75 19.625C17.4516 19.625 17.1655 19.5065 16.9545 19.2955C16.7435 19.0845 16.625 18.7984 16.625 18.5C16.625 18.2016 16.7435 17.9155 16.9545 17.7045C17.1655 17.4935 17.4516 17.375 17.75 17.375H26.75C27.0484 17.375 27.3345 17.4935 27.5455 17.7045C27.7565 17.9155 27.875 18.2016 27.875 18.5C27.875 18.7984 27.7565 19.0845 27.5455 19.2955C27.3345 19.5065 27.0484 19.625 26.75 19.625H17.75Z"
        fill="#34445A"
      />
      <path
        d="M16.625 13.25C16.625 12.9516 16.7435 12.6655 16.9545 12.4545C17.1655 12.2435 17.4516 12.125 17.75 12.125H29.75C30.0484 12.125 30.3345 12.2435 30.5455 12.4545C30.7565 12.6655 30.875 12.9516 30.875 13.25C30.875 13.5484 30.7565 13.8345 30.5455 14.0455C30.3345 14.2565 30.0484 14.375 29.75 14.375H17.75C17.4516 14.375 17.1655 14.2565 16.9545 14.0455C16.7435 13.8345 16.625 13.5484 16.625 13.25Z"
        fill="#34445A"
      />
      <path
        d="M16.625 8C16.625 7.70163 16.7435 7.41548 16.9545 7.2045C17.1655 6.99353 17.4516 6.875 17.75 6.875H29.75C30.0484 6.875 30.3345 6.99353 30.5455 7.2045C30.7565 7.41548 30.875 7.70163 30.875 8C30.875 8.29837 30.7565 8.58452 30.5455 8.7955C30.3345 9.00647 30.0484 9.125 29.75 9.125H17.75C17.4516 9.125 17.1655 9.00647 16.9545 8.7955C16.7435 8.58452 16.625 8.29837 16.625 8Z"
        fill="#34445A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 6.875C6.20163 6.875 5.91548 6.99353 5.7045 7.2045C5.49353 7.41548 5.375 7.70163 5.375 8C5.375 8.29837 5.49353 8.58452 5.7045 8.7955C5.91548 9.00647 6.20163 9.125 6.5 9.125H8.75C9.04837 9.125 9.33452 9.00647 9.5455 8.7955C9.75647 8.58452 9.875 8.29837 9.875 8C9.875 7.70163 9.75647 7.41548 9.5455 7.2045C9.33452 6.99353 9.04837 6.875 8.75 6.875H6.5ZM6.5 12.125C6.20163 12.125 5.91548 12.2435 5.7045 12.4545C5.49353 12.6655 5.375 12.9516 5.375 13.25C5.375 13.5484 5.49353 13.8345 5.7045 14.0455C5.91548 14.2565 6.20163 14.375 6.5 14.375H8.75C9.04837 14.375 9.33452 14.2565 9.5455 14.0455C9.75647 13.8345 9.875 13.5484 9.875 13.25C9.875 12.9516 9.75647 12.6655 9.5455 12.4545C9.33452 12.2435 9.04837 12.125 8.75 12.125H6.5Z"
        fill="#64748B"
      />
    </svg>
  );
};

